import React, { useContext } from 'react';

import { OrderScreenContext } from 'features/order-summary/screens/CheckoutScreen';
import { RadioItem } from 'features/product/components/RadioItem';
import { FamilyAddress } from 'common/api/crm/family/address/models/FamilyAddress';
import { createStyles } from 'utils/createStyle';

export interface OrderBillingAddressesProps {
    onEdit?: (address: FamilyAddress) => void;
    onChange: (address: FamilyAddress) => unknown;
    selectedAddressId?: string | undefined;
}

const styles = createStyles({
    list: ['overflow-auto', { maxHeight: '500px' }],
});

export const OrderAddresses = ({
    onEdit,
    onChange,
    selectedAddressId,
}: OrderBillingAddressesProps) => {
    const { cartInfoDetails } = useContext(OrderScreenContext);

    const addresses = [...(cartInfoDetails.shipping.userAddresses.addresses || [])];

    return (
        <div>
            <ul className={styles.list}>
                {addresses &&
                    addresses.reverse().map((address) => (
                        <li key={address.id}>
                            <div className="mb-2">
                                <RadioItem
                                    value={address.id}
                                    text={
                                        <div className="inline-block flex flex-row items-center">
                                            <div className="mr-auto inline-block flex flex-col w-full">
                                                <div className="text-brand">{`${address.firstName} ${address.lastName}`}</div>
                                                <div>{`${address.address1}${
                                                    address.address2 ? ', ' + address.address2 : ''
                                                }, ${address.city}, ${address.state}`}</div>
                                            </div>
                                            {onEdit && (
                                                <a
                                                    className="text-xs text-grey-1 cursor-pointer ml-auto"
                                                    onClick={() => onEdit(address)}
                                                >
                                                    Edit
                                                </a>
                                            )}
                                        </div>
                                    }
                                    selected={selectedAddressId === address.id}
                                    onClick={() => onChange(address)}
                                />
                            </div>
                        </li>
                    ))}
            </ul>
        </div>
    );
};
